export enum SortOrderEnum {
  asc = 'asc',
  desc = 'desc',
}
